//
//

import {
    pluginSizeRectangle,
    pluginSizeCircle
} from "../../../assets/js/Diagram/utils/constants";

export default {
    name: "PluginContainer",
    props: {
        plugin: Object,
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            previewInstance: null,
            isDragging: false,
            onHover: false,
            sizeCanvas: pluginSizeRectangle // default width / height
        };
    },
    created() {
        if (
            this.plugin
      && this.plugin.type
      && (this.plugin.type === "circle" || this.plugin.type === "rotated")
        ) {
            this.sizeCanvas = pluginSizeCircle;
        }
    },
    mounted() {
        const Plugin = this.plugin.plugin;
        this.$refs.canvas.getContext("2d").setTransform(1, 0, 0, 1, -0.5, -0.5);
        this.previewInstance = new Plugin(
            {
                position: {
                    x: 0,
                    y: 0
                },
                size: this.sizeCanvas
            },
            this.$refs.canvas.getContext("2d")
        );
        if (this.previewInstance.hasOwnProperty("radius")) {
            if (
                (this.previewInstance.name === "Task"
          || this.previewInstance.name === "Decisions",
                this.previewInstance.name === "External Task",
                this.previewInstance.name === "Generate Documents",
                this.previewInstance.name === "Api",
                this.previewInstance.name === "Blockchain")
            ) {
                this.previewInstance.radius = 0;
            }
        }
        this.previewInstance.preview = true;
        this.previewInstance.draw();
    },
    methods: {
        pluginClicked() {
            if (!this.readonly && !this.plugin.disabled) {
                this.$emit("SIDEBAR_CLICKED_PLUGIN", this.plugin);
            }
        },
        dragStart($event) {
            if (!this.plugin.disabled) {
                this.isDragging = true;
                $event.dataTransfer.setData("validPlugin", true);
                $event.dataTransfer.setData(
                    "data",
                    JSON.stringify({ pluginId: this.plugin.id })
                );
                if (this.plugin.hasOwnState) {
                    $event.dataTransfer.setData("hasOwnState", "");
                    if (this.plugin.defaultSize) {
                        $event.dataTransfer.setData(
                            `width:${this.plugin.defaultSize.width};height:${this.plugin.defaultSize.height}`,
                            ""
                        );
                    }
                }
            }
        },
        dragEnd() {
            // $event
            this.isDragging = false;
        }
    }
};
